import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const pushSupported = () =>
  "serviceWorker" in navigator && "PushManager" in window && "Notification" in window;

export const isIOS = () =>
  /iPhone|iPad|iPod/.test(navigator.userAgent) || (navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1);

export const isStandalone = () =>
  window.navigator.standalone === true || window.matchMedia("(display-mode: standalone)").matches;

const decodeKey = (base64) => {
  const pad = "=".repeat((4 - (base64.length % 4)) % 4);
  const raw = atob((base64 + pad).replace(/-/g, "+").replace(/_/g, "/"));
  return Uint8Array.from([...raw].map((c) => c.charCodeAt(0)));
};

const getRegistration = async () => {
  const existing = await navigator.serviceWorker.getRegistration("/");
  if (existing) return existing;
  await navigator.serviceWorker.register("/service-worker.js", { scope: "/" });
  return navigator.serviceWorker.ready;
};

export const getCurrentSubscription = async () => {
  if (!pushSupported()) return null;
  const reg = await navigator.serviceWorker.getRegistration("/");
  return reg ? reg.pushManager.getSubscription() : null;
};

export const enablePush = async () => {
  const permission = await Notification.requestPermission();
  if (permission !== "granted") throw new Error("denied");
  const reg = await getRegistration();
  const { data } = await axios.get(`${API}/push/public-key`);
  let sub = await reg.pushManager.getSubscription();
  if (!sub) sub = await reg.pushManager.subscribe({ userVisibleOnly: true, applicationServerKey: decodeKey(data.public_key) });
  const json = sub.toJSON();
  await axios.post(`${API}/push/subscribe`, { endpoint: json.endpoint, keys: json.keys, device_label: navigator.userAgent.slice(0, 120) });
  return sub;
};

export const disablePush = async () => {
  const sub = await getCurrentSubscription();
  if (!sub) return;
  await axios.post(`${API}/push/unsubscribe`, { endpoint: sub.endpoint });
  await sub.unsubscribe();
};
